var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBreadCrumbArrow = function SvgBreadCrumbArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 6,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5B5675",
    fillRule: "evenodd",
    d: "M.228.145A.51.51 0 0 1 .913.12l2.833 2.45c.195.17.206.454.023.637L1.12 5.855a.51.51 0 0 1-.685.025.43.43 0 0 1-.023-.637L2.73 2.926.25.782A.43.43 0 0 1 .228.145",
    clipRule: "evenodd"
  })));
};
export default SvgBreadCrumbArrow;